package org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("/kids/ride_to_read/class_2/little_turtle")
@Composable
fun LittleTurtlePage() {
    BlogLayout(
        PageProperties(
            "Little Turtle",
            ""
        ),
        BlogProperties("Ride To Reader", "Little Turtle - (Vachel Lindsay)")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There was a little turtle.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He lived in a box.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He swam in a puddle.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He climbed on the rocks.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He snapped at a mosquito.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He snapped at a flea.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He snapped at a minnow.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And he snapped at me.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He caught the mosquito.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He caught the flea.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He caught the minnow.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "But he didn't catch me.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            WebImage(
                src = Resources.Images.LITTLE_TURTLE,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Little Turtle"
            )

            SpanText(
                text = "Meaning",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "puddle: A very small pool of usually dirty or muddy water. A little pool of water on the ground. He likes to jump in the puddle.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "minnow: A very small fish. We Saw a minnow in the pond.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "flea: An insect that lives on other animals and birds, and sometimes even humans",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "snapped: Tried to bite. To suddenly try to bite something. The dog snapped at this beels.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Shell - The hard covering of a turtle",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Here is a story about Tommy the turtle, but the sentences are jumbled. Number the sentences in the correct order. The first one has been done for you.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tommy didn't like dogs because they turned him upside down.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tommy, the turtle, was asleep in a pile of leaves.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tommy quietly pulled his head and legs into his shell.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tommy was so happy that his idea worked!",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Suddenly, he woke up to the sound of a dog's bark.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He had an idea. He would pretend to be a rock.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He heard the dog sniff around and walk away.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Complete the following sentences.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There was a ________________. little turtle",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And he snapped ________________. at me",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He caught the ________________. mosquito/flea/minnow",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We see puddles on ________________. rainy day",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rocks are ________________. hard",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The little turtle swim in ________________. puddle",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The turtle did not caught the ________________. poet",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Short Answer Questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the little turtle live?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The little turtle lived in a box.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the turtle swim?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The turtle swam in a puddle.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the turtle climb on?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The turtle climbed on the rocks.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the turtle snap at?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The turtle snapped at the mosquito, flea, minnow and at me.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the turtle catch?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The turtle caught the mosquito, flea and minnow.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Do you think the turtle was active? Why?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Yes. He swam, climbed, and tried to catch many small creatures.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the poet doing in the poem?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet is describing his little pet turtle and it's funny activities.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "He snapped at me who is me in the poem?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The word me in the poem means the poet.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Do you think the turtle is the poet's pet explain why?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Yes, the turtle is the poet pet because it lives in a box and he knows about it's activities.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Name three things the turtle snapped at.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "A mosquito, a flea, and a minnow.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why do you think the turtle was annoyed with everybody?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The turtle was annoyed because he kept snapping at everything around him showing be was irritated (ચિડાયેલું) or playful.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Describe all the things that the turtle did.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The turtle lived in a box, swam in a puddle, climbed on rocks, snapped at a mosquito, a flea, a minnow and the poet. He caught the mosquito, the flea and the minnow.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who is watching the turtle do these things?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The poet is watching The turtle.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the meaning of minnow?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Minnow means a small fish.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }

            SpanText(
                text = "One double letter word is spelt incorrectly in each of the given sentences. Underline the word and write the correct spelling in the blank provided. Remember the floss and rabbit rules while answering. One has been done as an example.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The old lady lives in a ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "cotage.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "I can ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "spel ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "difficult words.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sheila looked at herself in the ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "mirar.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dad is mowing the ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "gras.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There is a lot of ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "traffc ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "on the road.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Put the ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "rubish ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "in the bin.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "buzing ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "bees moved around the tree.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Number the sentences to show the correct order.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "4. But he didn't catch me.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "1. He climbed on the rocks.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "2. He snapped at the mosquito.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "3. He caught the flea.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//https://www.youtube.com/watch?v=3Y7rOr9gBuM